import axios from "axios";
import config from "clientappsetting.json";

class HttpClient {

    public axiosInstance = axios.create({
        baseURL: config.API_URL
    });

    constructor() {
    }

    setToken(token: string) {
        this.axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }

    setBaseURL(url: string) {
        this.axiosInstance.defaults.baseURL = url;
    }

}

const httpClient = new HttpClient();

export const setAuthToken = httpClient.setToken.bind(httpClient);
export const setBaseURL = httpClient.setBaseURL.bind(httpClient);
export const http = httpClient.axiosInstance;
